import { addTelemetryError, display, DOCS_ORIGIN } from '@datadog/browser-core';
export function reportScriptLoadingError(_ref) {
  var configuredUrl = _ref.configuredUrl,
    error = _ref.error,
    source = _ref.source,
    scriptType = _ref.scriptType;
  display.error("".concat(source, " failed to start: an error occurred while initializing the ").concat(scriptType, ":"), error);
  if (error instanceof Event || error instanceof Error && isMessageCspRelated(error.message)) {
    var baseMessage;
    if (configuredUrl) {
      baseMessage = "Please make sure the ".concat(scriptType, " URL ").concat(configuredUrl, " is correct and CSP is correctly configured.");
    } else {
      baseMessage = 'Please make sure CSP is correctly configured.';
    }
    display.error("".concat(baseMessage, " See documentation at ").concat(DOCS_ORIGIN, "/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
  } else if (scriptType === 'worker') {
    addTelemetryError(error);
  }
}
function isMessageCspRelated(message) {
  return message.includes('Content Security Policy') ||
  // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
  message.includes("requires 'TrustedScriptURL'");
}